import React from 'react';
import { Canvas, IText } from 'fabric';
import { Select, InputNumber, Tooltip } from 'antd';
import { FONT_UI } from '../../../constants/design-tokens';
import { useTextLineHeight, useTextStyleField } from '../../hooks/use-text-style-field';
import { FONT_FAMILY_OPTIONS } from '../../constants/fonts';
import { TEXT_DEFAULTS } from '../../constants/text-defaults';

interface FontControlsProps {
  textObject: IText;
  canvas: Canvas;
}

export const FontControls: React.FC<FontControlsProps> = ({ textObject, canvas }) => {
  const [fontFamily, setFontFamily] = useTextStyleField(textObject, canvas, 'fontFamily', TEXT_DEFAULTS.fontFamily);
  const [fontSize, setFontSize] = useTextStyleField(textObject, canvas, 'fontSize', TEXT_DEFAULTS.fontSize);
  const [lineHeight, setLineHeight] = useTextLineHeight(TEXT_DEFAULTS.lineHeight);

  return (
    <>
      <Select
        value={fontFamily}
        onChange={setFontFamily}
        options={FONT_FAMILY_OPTIONS}
        size='small'
        style={{ width: '130px', fontFamily: FONT_UI }}
        variant='borderless'
      />
      <InputNumber value={fontSize} onChange={v => v != null && setFontSize(v)} min={1} />
      <Tooltip title='Interlineado'>
        <InputNumber
          value={lineHeight}
          onChange={v => v != null && setLineHeight(v)}
          min={0.5}
          max={3}
          step={0.1}
          precision={2}
        />
      </Tooltip>
    </>
  );
};
